import { ROLES } from "./roles";

export function getActivityLabel(role) {
  if (role === ROLES.LIBRARY) return "Faaliyet Değerlendirme";
  if (role === ROLES.ACADEMIC) return "Faaliyetlerim";
  return "Faaliyet Kayıtları";
}

export function getDefaultRouteByRole(role) {
  if (role === ROLES.ADMIN) return "/admin";
  if (role === ROLES.RECTOR) return "/performance-center";
  if ([ROLES.DEAN, ROLES.DEPARTMENT_HEAD].includes(role)) return "/academic-report";
  if ([ROLES.ACADEMIC, ROLES.LIBRARY].includes(role)) return "/academic-activities";
  return "/login";
}
